import { Component, OnInit } from '@angular/core';
import { PrintService } from 'src/app/core/services/print.service';
import { Partner } from 'src/app/shared/models/clients/partner';

@Component({
  selector: 'app-print-client-partners',
  templateUrl: './print-client-partners.component.html',
  styleUrls: ['./print-client-partners.component.scss']
})
export class PrintClientPartnersComponent implements OnInit {

  partners: Partner[] = [];
  clientName: string;

  constructor(
    private printService: PrintService,
  ) {
    this.partners = this.printService.data.partners;
    this.clientName = this.printService.data.clientName;
  }

  ngOnInit(): void {
    this.printService.onDataReady('Client Management');
  }

}
